module.exports = __webpack_public_path__ + "static/media/Adrian Butscher.dd996916.png";